module.exports = __webpack_public_path__ + "img/Vector-home.3e6856f9.svg";